import React from "react";
import PropTypes from "prop-types";
import Hotkeys from "react-hot-keys";

class HotKeysSwitch extends React.Component {
    componentDidMount() {
        this.blockAltArrowsEvents();
        if (!this.dashboardRotationInterval) {
            this.autoSwitch(this.props.dashboardRotation);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            !this.dashboardRotationInterval ||
            prevProps.rotationPaused !== this.props.rotationPaused
        ) {
            this.autoSwitch(this.props.dashboardRotation);
        }
    }

    componentWillUnmount() {
        clearInterval(this.dashboardRotationInterval);
    }

    blockAltArrowsEvents = () => {
        const KeyPress = (e) => {
            if (e.code === "ArrowLeft" && e.altKey) {
                e.preventDefault();
            }

            if (e.code === "ArrowRight" && e.altKey) {
                e.preventDefault();
            }
        };
        document.onkeydown = KeyPress;
    };

    onKeyUp(keyName) {
        if (!this.props.hotkeysEnabled) {
            return;
        }
        if (!this.props.currentDashboard) {
            return;
        }
        const currentId = this.props.currentDashboard.id;
        const isFavouriteDashboard = this.idExists(currentId);
        const favoritesIds = this.getFavoritesIds();

        if (isFavouriteDashboard) {
            let index = 0;
            const currentIdIndex = favoritesIds.indexOf(currentId);

            switch (keyName) {
                case "alt+right":
                    index = currentIdIndex + 1 < favoritesIds.length ? currentIdIndex + 1 : 0;
                    break;
                case "alt+left":
                    index = currentIdIndex === 0 ? favoritesIds.length - 1 : currentIdIndex - 1;
                    break;

                default:
                    index = currentIdIndex;
            }

            this.props.history.push(`/dashboard/view/${favoritesIds[index]}`);
        }
    }

    idExists = (currentId) => !!this.props.favorites.find((o) => o.id === currentId);

    getFavoritesIds = () => this.props.favorites.map((dashboard) => dashboard.id);

    autoSwitch = (time) => {
        if (this.props.rotationPaused) {
            if (this.dashboardRotationInterval) {
                clearInterval(this.dashboardRotationInterval);
                this.dashboardRotationInterval = null;
            }
            return;
        }
        if (!this.props.dashboardRotation) {
            return;
        }
        if (!this.props.currentDashboard) {
            return;
        }
        if (this.props.isEditAllowed) {
            if (this.dashboardRotationInterval) {
                clearInterval(this.dashboardRotationInterval);
                this.dashboardRotationInterval = null;
            }
            return;
        }
        const currentId = this.props.currentDashboard.id;
        const isFavouriteDashboard = this.idExists(currentId);
        const favoritesIds = this.getFavoritesIds();

        if (isFavouriteDashboard) {
            const currentIdIndex = favoritesIds.indexOf(currentId);

            const index = currentIdIndex + 1 < favoritesIds.length ? currentIdIndex + 1 : 0;

            if (!this.dashboardRotationInterval) {
                this.dashboardRotationInterval = setInterval(() => {
                    this.props.history.push(`/dashboard/view/${favoritesIds[index]}`);
                }, time);
            }
        }
    };

    render() {
        return <Hotkeys keyName="alt+left, alt+right" onKeyUp={this.onKeyUp.bind(this)} />;
    }
}

HotKeysSwitch.propTypes = {
    openDashboard: PropTypes.func,
    favorites: PropTypes.arrayOf(PropTypes.any),
    history: PropTypes.objectOf(PropTypes.any),
    currentDashboard: PropTypes.objectOf(PropTypes.any),
    dashboardRotation: PropTypes.number.isRequired,
    hotkeysEnabled: PropTypes.bool,
    rotationPaused: PropTypes.bool,
};

HotKeysSwitch.defaultProps = {
    openDashboard: undefined,
    favorites: [],
    history: {},
    currentDashboard: {},
    hotkeysEnabled: false,
    rotationPaused: false,
};

export default HotKeysSwitch;
